export default "__VITE_ASSET__CaEFtdYI__"